"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _hubspot = _interopRequireDefault(require("hubspot"));

var _invariant = _interopRequireDefault(require("react-utils/invariant"));

var _performance = _interopRequireDefault(require("../../vendor/performance"));

var _BaseReporter2 = _interopRequireDefault(require("./BaseReporter"));

var _ReporterActionTypes = _interopRequireDefault(require("./ReporterActionTypes"));

var STATIC_DOMAIN_REGEX = /https:\/\/(static|local).hsappstatic.net\//; // If the duration of the request is <= 10ms mark the request as a cache hit.

var CACHE_DURATION_MS = 10;

var ReaganCompatReporter = /*#__PURE__*/function (_BaseReporter) {
  (0, _inherits2.default)(ReaganCompatReporter, _BaseReporter);

  function ReaganCompatReporter() {
    var _this;

    (0, _classCallCheck2.default)(this, ReaganCompatReporter);
    _this = (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(ReaganCompatReporter).call(this));
    _this.abandonedTimes = [];
    _this.lastAbandonedTimestamp = null;
    _this.finished = false;
    return _this;
  }

  (0, _createClass2.default)(ReaganCompatReporter, [{
    key: "getHubHttpData",
    value: function getHubHttpData(finishedTimestamp) {
      if (typeof _hubspot.default.getAllHttpRequestStats === 'function' && typeof _performance.default.now === 'function') {
        var byStatus = function byStatus(status) {
          return function (_ref) {
            var state = _ref.state,
                started = _ref.started,
                finished = _ref.finished;
            return started < finishedTimestamp && (status === 'pending' ? state === 'pending' || finished > finishedTimestamp : state === status && finished <= finishedTimestamp);
          };
        };

        var MAX_URLS = 10;

        var toUrls = function toUrls(arr) {
          return arr.slice(0, MAX_URLS).map(function (r) {
            return r.url;
          }).join(',');
        };

        var requests = _hubspot.default.getAllHttpRequestStats();

        var succeededRequests = requests.filter(byStatus('succeeded'));
        var failedRequests = requests.filter(byStatus('failed'));
        var abortedRequests = requests.filter(byStatus('aborted'));
        var pendingRequests = requests.filter(byStatus('pending'));
        var timedOutRequests = requests.filter(byStatus('timedOut'));
        var failedRequestsMinus404AndRetries = failedRequests.filter(function (r) {
          return r.status !== 404 && !r.willBeRetried;
        });
        var notFoundRequests = failedRequests.filter(function (r) {
          return r.status === 404;
        });
        return {
          numSucceededRequests: succeededRequests.length,
          numAbortedRequests: abortedRequests.length,
          numPendingRequests: pendingRequests.length,
          numNotFound: notFoundRequests.length,
          numTimedoutRequests: timedOutRequests.length,
          numFailedRequestsMinus404AndRetries: failedRequestsMinus404AndRetries.length,
          numRetriedFailures: failedRequests.filter(function (r) {
            return !!r.willBeRetried;
          }).length,
          failedRequestUrls: toUrls(failedRequestsMinus404AndRetries),
          timedOutRequestUrls: toUrls(timedOutRequests),
          pendingRequestUrls: toUrls(pendingRequests),
          notFoundUrls: toUrls(notFoundRequests)
        };
      }

      return null;
    }
  }, {
    key: "getCacheStatusData",
    value: function getCacheStatusData() {
      var cacheStatusData = {};
      this.performanceEntries().forEach(function (timing) {
        if (timing.name.endsWith('.js')) {
          var fileName = timing.name.replace(STATIC_DOMAIN_REGEX, '');
          cacheStatusData[fileName] = {
            cached: timing.duration <= CACHE_DURATION_MS,
            duration: timing.duration
          };
        }
      });
      return cacheStatusData;
    }
  }, {
    key: "getNumFailedImages",
    value: function getNumFailedImages() {
      return Array.from(document.getElementsByTagName('img')).reduce(function (total, ele) {
        return ele.src && ele.naturalHeight === 0 && ele.naturalWidth === 0 ? total + 1 : total;
      }, 0);
    }
  }, {
    key: "finish",
    value: function finish(attrs, checks) {
      var _this2 = this;

      var finishedTimestamp = attrs.finishedTimestamp;
      var hubHttpData = this.getHubHttpData(finishedTimestamp);
      var avgDurationBeforePreviousReaganAborts = this.abandonedTimes.reduce(function (acc, duration) {
        return acc + duration / _this2.abandonedTimes.length;
      }, 0);
      var cacheData = this.getCacheStatusData();
      var reaganTiming = {};
      Object.keys(checks).forEach(function (marker) {
        if (checks[marker].mounted) {
          reaganTiming["marker_timing_" + marker] = checks[marker].timestamp;
        }
      });
      this.setCustomAttribute('numReaganChecksStarted', this.abandonedTimes.length + 1);
      this.setCustomAttribute('numPreviousReaganChecksAborted', this.abandonedTimes.length);
      this.setCustomAttribute('avgDurationBeforePreviousReaganAborts', avgDurationBeforePreviousReaganAborts);
      this.setCustomAttribute('numPreviousReaganChecksFailed', 0);
      this.setCustomAttribute('numPreviousReaganChecksSuccessful', 0);
      this.setCustomAttribute('supportsUserTiming', typeof _performance.default.mark === 'function');
      this.setCustomAttribute('supportsPerformanceTimeline', typeof _performance.default.getEntriesByType === 'function');
      this.setCustomAttribute('supportsHighResolutionTime', typeof _performance.default.now === 'function');
      this.addPageAction('reaganFinished', Object.assign({}, attrs, {}, hubHttpData, {
        numFailedImages: this.getNumFailedImages(),
        cacheData: JSON.stringify(cacheData)
      }, reaganTiming));
    }
  }, {
    key: "report",
    value: function report(action) {
      if (!this || this.finished) {
        return;
      }

      var _action$payload = action.payload,
          _action$payload$entry = _action$payload.entry,
          timestamp = _action$payload$entry.timestamp,
          checks = _action$payload$entry.checks,
          expiredTimestamp = _action$payload$entry.expiredTimestamp,
          pathname = _action$payload$entry.pathname,
          routeSpec = _action$payload.routeSpec;

      switch (action.type) {
        case _ReporterActionTypes.default.ROUTE_SUCCEEDED:
        case _ReporterActionTypes.default.ROUTE_FAILED:
        case _ReporterActionTypes.default.ROUTE_TIMEOUT_EXPIRED:
        case _ReporterActionTypes.default.ROUTE_UNEXPECTED:
          {
            this.finished = true;
            break;
          }

        default:
      }

      switch (action.type) {
        case _ReporterActionTypes.default.ROUTE_STARTED:
          {
            if (this.lastAbandonedTimestamp) {
              this.abandonedTimes.push(timestamp - this.lastAbandonedTimestamp);
            }

            break;
          }

        case _ReporterActionTypes.default.ROUTE_ABANDONED:
          {
            this.lastAbandonedTimestamp = timestamp;
            break;
          }

        case _ReporterActionTypes.default.ROUTE_SUCCEEDED:
          {
            var success = routeSpec.success,
                route = routeSpec.route;
            var scenario = action.payload.extra.scenario;

            if (process.env.NODE_ENV !== 'production') {
              (0, _invariant.default)(success[scenario].length > 0, 'routeSpec for %s must have at least one `success` marker for %s', route, scenario);
            }

            var maxTimestamp = Math.max.apply(Math, (0, _toConsumableArray2.default)(success[scenario].map(function (m) {
              return checks[m].timestamp;
            })));
            var duration = Math.max(0, maxTimestamp - timestamp);
            this.finish({
              status: 'success',
              timeToAllSuccess: (timestamp + duration) / 1000,
              scenario: scenario,
              finishedTimestamp: maxTimestamp,
              route: route,
              pathname: pathname
            }, checks);
            this.performanceMark("mark_all_success");
            break;
          }

        case _ReporterActionTypes.default.ROUTE_FAILED:
          {
            var _route = routeSpec.route,
                error = routeSpec.error;
            var markers = error.filter(function (marker) {
              return checks[marker] && checks[marker].mounted;
            });

            if (process.env.NODE_ENV !== 'production') {
              (0, _invariant.default)(markers.length > 0, 'routeSpec for %s must have at least one `failure` marker for', _route);
            } // TODO how to report multiple failed markers without separate page actions


            var _markers = (0, _slicedToArray2.default)(markers, 1),
                failedMarker = _markers[0];

            var finishedTimestamp = checks[failedMarker].timestamp;
            this.finish({
              status: 'failure',
              failureType: 'errorSelector',
              selector: failedMarker,
              finishedTimestamp: finishedTimestamp,
              route: _route,
              pathname: pathname
            }, checks);
            this.performanceMark("mark_all_failure");
            break;
          }

        case _ReporterActionTypes.default.ROUTE_TIMEOUT_EXPIRED:
          {
            var _route2 = routeSpec.route;
            this.finish({
              status: 'failure',
              failureType: 'watchdogExpired',
              finishedTimestamp: expiredTimestamp,
              route: _route2
            }, checks);
            this.performanceMark("mark_all_failure_watchdog_expired");
            break;
          }

        default:
      }
    }
  }]);
  return ReaganCompatReporter;
}(_BaseReporter2.default);

exports.default = ReaganCompatReporter;
module.exports = exports.default;